import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgIconsModule } from '@ng-icons/core';
import { TrialService } from 'src/app/services/trial.service';


@Component({
  selector: 'app-modal-trial-saude',
  templateUrl: './trial-saude.component.html',
  imports: [CommonModule, NgIconsModule],
})
export class ModalTrialSaudeComponent {
  private readonly dialogRef = inject(MatDialogRef<ModalTrialSaudeComponent>);
  private readonly trialService = inject(TrialService);

  carregando = false;

  cancelar() {
    this.dialogRef.close();
  }

  async iniciarTeste() {
    this.carregando = true

    await this.trialService.iniciarTeste()

    this.carregando = false
  }
}
